import {combineReducers} from 'redux';
import LoginStatusReducer from './reducer-login-status';
import FacebookLoginReducer from './reducer-facebook-login';
import CurrentLanguageReducer from './reducer-current-language';
import BotsReducer from './reducer-bots';
import CurrentBotReducer from './reducer-current-bot';
import CurrentSubjectReducer from './reducer-current-subject';
import PagesReducer from './reducer-pages';
import SelectBotReducer from './reducer-select-bot';
import SelectSubjectReducer from './reducer-select-subject';
import LoadingReducer from './reducer-loading';
import NavigationReducer from './reducer-navigation';

export const allReducers = combineReducers({
	loginStatus: LoginStatusReducer,
	facebookLogin: FacebookLoginReducer,
	currentLanguage: CurrentLanguageReducer,
	currentBot: CurrentBotReducer,
	currentSubject: CurrentSubjectReducer,
	bots: BotsReducer,
	pages: PagesReducer,
	selectedBot: SelectBotReducer,
	selectedSubject: SelectSubjectReducer,
	isLoading: LoadingReducer,
	isNavOpen: NavigationReducer
});

export default allReducers;


// WEBPACK FOOTER //
// ./src/redux/reducers/index.js